/* eslint-disable */
/* jscs:disable */

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import * as echarts from 'echarts';
import {createApp, h} from 'vue';
import App from './App.vue';
import './js/filters';
import './js/global';
import bus from './shared/event-bus.js';
import router from './router';
import store from './js/store';
import lodash from 'lodash';
import {useMq, Vue3Mq} from 'vue3-mq';
import Vue3linkify from 'vue-3-linkify'

window.echarts = echarts;
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import { BootstrapVueNext } from 'bootstrap-vue-next';
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";

export const EventBus = bus;
export const app = createApp({
    router,
    store,
    render: () => ( h(App)),
    async created () {
        
    },
}).use(lodash).use(router).use(Vue3Mq, {
    preset: 'bootstrap4',
    global: true,
    breakpoints: {
        xs: 0,
        sm: 768,
        md: 992,
        lg: 1200,
        xl: 1400,
        xxl: 2500
    }
}).use(BootstrapVueNext).use(store).use(Vue3linkify).mount('#app');

app.$options.$filters = window.filters;